import i18n from 'live/services/i18n'
import widgetService from 'live/services/widgets'
import StateTimelineChart from './StateTimelineChart'
import { widgetWrapper } from 'live/widgets/decorators/pure'
import stateTimelineReducer from './StateTimelineReducer'
import StateTimelineConfigForm from './StateTimelineConfigForm'

const widgetType = 'statetimeline'

const StateTimelineWidget = widgetWrapper(StateTimelineChart, stateTimelineReducer, {
    mapConfigToRender(configs) {
        return {
            widget: configs.widget,
            dashboardTheme: configs.dashboardContext.theme
        }
    },
    sampleTime: 500
})

const DEFAULT_CHART_CONFIG = {
    verticalEnabled: false,
    numberOfVisibleAxes: 6,
    legendEnabled: false,
    legendRight: false,
    hideTooltip: true,
    tooltipOption: 'off'
}

const policies = {
    layers: 1,
    legends: false,
    allowHideTooltip: false,
    allowYAxisConfig: false,
    allowGroupedYAxis: false,
    defaultReducer: 'list(*) at the end => @chain' //,
    // handleOwnMissingData: true
}

widgetService.register({
    type: widgetType,
    get name() {
        return 'State timeline'
    },
    description: i18n('state timeline description'),
    policies,
    config: DEFAULT_CHART_CONFIG,
    ui: { configForm: StateTimelineConfigForm },
    impl: StateTimelineWidget
})
